import React from 'react'
import { STATIC_URL } from '../../Env'
import { AuthorRow } from '../Blog/AuthorRow'

const NewsSection = ({posts}) => {

  return (
    <div className="news-section container">
      <div className="section-head float-left">
        <h3 className="section-title">Latest news <span><a href="/">See all news</a></span> </h3>
      </div>

      <div className="row">
        <div className="col-12 col-md-6">
          <div className="post-item">
            <div className="post-image">
              <img src={`${STATIC_URL}${posts[0].picture}`} alt="news" />
            </div>
            <h4>{posts[0].title}</h4>
            <p className="post-content">{posts[0].content}</p>
            <AuthorRow author={posts[0].author} author_pic={posts[0].author_pic} post={posts[0]}/>
          </div>
        </div>
        <div className="col-12 offset-0 offset-md-1 col-md-5 col-lg-4">
          {posts.slice(1).map((post) => (
            <div className="post-item post-mini">
              <h4>{post.title}</h4>
              <p className="post-content">{post.content}</p>
              <AuthorRow author={post.author} author_pic={post.author_pic} post={post}/>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) 
}


export default NewsSection
